import { useEffect, useState } from 'react';
import { tokens } from '../../theme';
import { creatorApi, type CreatorEarnings } from '../../lib/api';

function money(c: number) { return `$${(c / 100).toLocaleString(undefined, { minimumFractionDigits: 2 })}`; }

export function EarningsTab() {
  const [e, setE] = useState<CreatorEarnings | null>(null);
  useEffect(() => { creatorApi.earnings().then(setE).catch(() => setE({ total_earned_cents: 0, paid_cents: 0, clips_verified: 0, total_views: 0 })); }, []);
  if (!e) return <p style={{ color: tokens.color.ink[500] }}>Loading earnings...</p>;
  const stat = (label: string, value: string) => (
    <div style={{ background: tokens.color.paper['00'], border: `1px solid ${tokens.color.line[100]}`, borderRadius: 12, padding: 20 }}>
      <div style={{ fontFamily: tokens.font.mono, fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: tokens.color.ink[500] }}>{label}</div>
      <div style={{ fontFamily: tokens.font.display, fontWeight: 600, fontSize: 28, marginTop: 6 }}>{value}</div>
    </div>
  );
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px,1fr))', gap: 16 }}>
      {stat('Total earned', money(e.total_earned_cents))}
      {stat('Paid out', money(e.paid_cents))}
      {stat('Verified clips', String(e.clips_verified))}
      {stat('Total views', e.total_views.toLocaleString())}
    </div>
  );
}
